import React from 'react';
import { ReactComponent as File } from './logo.svg';

export default function Logo() {
  return <File />;
}
